<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<Add ref="FormData" @closeEdit="closeEdit" :dialogVisible="dialogVisible" :type="type"></Add>
		<AddPro ref="Addlocal" :showlocal="showlocal" @closeLocal="closeLocal"></AddPro>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div class="leftBar">
							<el-input
								size="small"
								placeholder="请输入组织名称"
								prefix-icon="el-icon-search"
								style="width: 200px;"
								v-model="getdata.dw_name"
								@input="getdata.page = 1;totalPage = 0;dataList();">
							</el-input>
							<el-select 
								style="margin-left: 20px;" 
								v-model="getdata.organ_class" 
								placeholder="请选择"
								clearable
								size="small"
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									v-for="item in selectClass"
									:key="item.value"
									:label="item.option"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="rightBar">
							<el-button type="primary" 
							 size="small"
							v-if="$store.state.user.userinfo.id==332||$store.state.user.userinfo.p_id==332" 
							@click="showlocal = true;$refs.Addlocal.bindata();$refs.Addlocal.provinceList()">新增所在地</el-button>
							<el-button type="primary" size="small" @click="dialogVisible = true;type = 'add';$refs.FormData.pOran()">新增</el-button>
							<el-button type="primary" size="small" @click="daochu">导出通讯录</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="false">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { djxc,dwgl } from '@/axios'
	import Page from '@/components/page.vue'
	import DelData from '@/components/delToast.vue'
	import { Message } from 'element-ui'
	import Add from './components/add_zz.vue'
	import AddPro from './components/add_local.vue'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					user_id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					dw_name:"",
					organ_class:"",
					sign:1,
					page:1
				},
				delList:[],
				tableData:[],
				totalPage:0,
				selectClass:[],
				dialogVisible:false,//新增/编辑弹窗
				showlocal:false,
				type:'add',//编辑/新增,
				tableHeader: [     // 表头
					{prop: 'dw', label: '组织名称',width:''},
					{prop: 'organ_class_name', label: '组织类型',formatData: function (val) {
						if(!val){
							return '未选择组织类型'
						}else{
							return val
						}
					}},
					{prop: 'p_name', label: '上级党组织',width:'180'},
					{prop: 'head_name', label: '负责人',width:"80"},
					{prop: 'head_phone', label: '联系电话',width:'130'},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '120',align:'center',
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail,show:true,limit:''},
							{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit,show:true,limit:''},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del,show:true,limit:''},
						]
					}
				]
			}
		},
		components:{Page,DelData,Add,AddPro,myTables},
		created(){that = this;},
		methods:{
			// 支部列表
			dataList(){
				dwgl.partyOrgan(that.getdata).then(res => {
					if(res.data.pagedata!=null){
						that.tableData = res.data.pagedata;
						that.totalPage = res.data.count;
					}else{
						that.tableData = [];
					}
				})
			},
			// 关闭所在地新增窗口
			closeLocal(){
				that.showlocal = false;
				that.dataList();
			},
			showDetail(data){
				that.$router.push({
					path:'/dzz_detail',
					query:{
						id:data.id,
						flag:data.flag,
						pid:data.p_id
					}
				})
			},
			// 编辑
			edit(data){
				that.dialogVisible = true;
				that.type = 'edit';
				that.$refs.FormData.bindData(data)
				that.$refs.FormData.pOran();
				that.$refs.Addlocal.provinceList()
			},
			// 关闭弹窗
			closeEdit(){
				that.dialogVisible = false;
				that.dataList();
			},
			//	删除操作
			del(data){
				that.$refs.delDatas.showToast(res => {
					if(res){
						dwgl.delOrgan({
							id:data.id,
							flag:data.flag,
							p_id: data.p_id,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 树形结构筛选
			treeSelect(data){
				that.getdata.id = data.id;
				that.getdata.flag = data.flag;
				that.getdata.page = 1;
				that.dataList();
			},
			// 分页筛选
			changedata(val) {
				that.getdata.page = val;
				that.dataList();
			},
			// 导出
			daochu(){
				dwgl.exportPartyOrgan({
					user_id: that.getdata.user_id,
					flag: that.getdata.flag,
					organ_class:  that.getdata.organ_class,
					sign: 1
				})
			}
		},
		mounted() {
			that.dataList();
			dwgl.organClass().then(res => {
				that.selectClass = res
			});
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
	}
</style>

